// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-spark';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.656 2.808h14.616c.648 0 1.152.504 1.152 1.152v10.152c0 .648-.504 1.152-1.152 1.152H1.656a1.137 1.137 0 0 1-1.152-1.152V3.96c.072-.648.576-1.152 1.152-1.152z' />
    <path d='m2.808 11.232 2.376-3.888 2.16 3.888L9.576 9l2.232 2.232 3.384-5.04' />
  </g>
);

export const viewBox = '0 0 18 18';
